// extracted by mini-css-extract-plugin
export default {"myCourseBox":"my-course_myCourseBox__DUBif","queryBox":"my-course_queryBox__tQcOZ"};